import { useTranslate } from '../../../i18n/useTranslationModules';

export const RequiredFieldsLegend = (): JSX.Element => {
	const { t } = useTranslate('homepage');

	return (
		<p className="visually-hidden">
			{t('registration.RequiredFieldsLegend', 'Fields marked with an asterisk (*) are required.')}
		</p>
	);
};
